import { FC, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Divider, Popover, Typography } from '@mui/material';

import TgIconWhiteBg from '../../assets/images/TG ICON WHITE BG copy 1.png';
import HeroImage from '../../assets/images/Ellipse 118.png';
import BellIcon from '../../assets/icons/user-info/Bell, Notification.png';
import ExitIcon from '../../assets/icons/user-info/Exit, Log out.png';
import UserIcon from '../../assets/icons/user-info/user.png';
import CarIcon from '../../assets/icons/user-info/car-outline.png';
import PlansIcon from '../../assets/icons/user-info/check-lust-text.png';
import DocumentIcon from '../../assets/icons/documentIcon.png';

import { useDispatch } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
// import CustomButton from '../CustomButton';
import { useGetUserQuery } from '../../store/services/customizeOptionsApi';
import { useAppSelector } from '../../hooks/redux';
import { logOutUser, setUserInfo } from '../../store/slices/userSlice';
import { api } from '../../store/services/api';

import styles from './UserInfoWrapper.module.scss';

type UserInfoWrapperProps = {}

const UserInfoWrapper: FC<UserInfoWrapperProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const {user, auth} = useAppSelector((state) => state);

  const { data: userData } = useGetUserQuery({});

  useEffect(() => {
    if (userData && auth.userInfo.access) {
      dispatch(setUserInfo(userData));
    }
  },[userData]);

  const handleActivePage = (pageName: 'profile' | 'trips' | 'plans' | 'documents') => {
    navigate(`/${pageName}`);
  }

  const handleLogout = () => {
    localStorage.removeItem('userInfo');
    dispatch(api.util.resetApiState());
    dispatch(logOutUser());
    dispatch(logout());
  };

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handlePopupClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopupClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'nav-popover' : undefined;

  return (
    <Container maxWidth="lg" sx={{ padding: '0 !important' }}>
      <Box className={styles.userInfoHeader}>
        <Box className={styles.logoContainer} onClick={() => navigate('/profile')}>
          <img className={styles.logoImg} src={TgIconWhiteBg} alt="logo" />
          <Typography variant='h8Bold'>TravGenius</Typography>
        </Box>
        <Box className={styles.navSection}>
          <img src={BellIcon} alt='notify' />
          {/* <CustomButton variant='contained' onClick={handlePopupClick}>
            + Create new
          </CustomButton> */}

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopupClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Box
              className={styles.popoverBtn}
              onClick={() => handleActivePage('plans')}
            >
              <img src={PlansIcon} alt='plans icon' />
              <Typography variant='h10' className={styles.nickNameText}>Plan</Typography>
            </Box>
            <Divider />
            <Box
              className={styles.popoverBtn}
              onClick={() => handleActivePage('trips')}
            >
              <img src={CarIcon} alt='trip icon' />
              <Typography variant='h10' className={styles.nickNameText}>Trip</Typography>
            </Box>
          </Popover>
        </Box>
      </Box>

      <Box className={styles.userInfoContent}>
        <Box className={styles.userInfoContentLeft}>
          <Box className={styles.infoSection}>
            <Box className={styles.mainInfo}>
              <img src={HeroImage}  className={styles.heroImg} alt='hero image' />
              <Box className={styles.mainInfoText}>
                <Typography variant='h6Bold' className={styles.nameText}>{`${user.first_name} ${user.last_name}`}</Typography>
                <Typography variant='h10' className={styles.nickNameText}>@{`${user.username}`}</Typography>
              </Box>
            </Box>

            <Box className={styles.mainMenu}>
              <Box
                className={`${styles.menuBtn} ${pathname === '/profile' ? styles.activeMenuBtn : ''}`}
                onClick={() => handleActivePage('profile')}
              >
                <img src={UserIcon} alt='user icon' />
                <Typography variant='h10' className={styles.nickNameText}>Profile</Typography>
              </Box>
              <Box
                className={`${styles.menuBtn} ${pathname === '/trips' ? styles.activeMenuBtn : ''}`}
                onClick={() => handleActivePage('trips')}
              >
                <img src={CarIcon} alt='trip icon' />
                <Typography variant='h10' className={styles.nickNameText}>My trips</Typography>
              </Box>
              <Box
                className={`${styles.menuBtn} ${pathname === '/plans' ? styles.activeMenuBtn : ''}`}
                onClick={() => handleActivePage('plans')}
              >
                <img src={PlansIcon} alt='plans icon' />
                <Typography variant='h10' className={styles.nickNameText}>My plans</Typography>
              </Box>
              <Box
                className={`${styles.menuBtn} ${pathname === '/documents' ? styles.activeMenuBtn : ''}`}
                onClick={() => handleActivePage('documents')}
              >
                <img src={DocumentIcon} className={styles.documentIcon} alt='plans icon' />
                <Typography variant='h10' className={styles.nickNameText}>Documents</Typography>
              </Box>
            </Box>
          </Box>

          <Box className={styles.menuExitBtnWrapper}>
            <Box className={styles.menuExitBtn} onClick={handleLogout}>
              <img src={ExitIcon} alt='exit icon' />
              <Typography variant='h10' className={styles.nickNameText}>Log out</Typography>
            </Box>
          </Box>
        </Box>

        <Box className={styles.userInfoContentRight}>
          <Outlet />
        </Box>
      </Box>
    </Container>
  )
}

export default UserInfoWrapper;
